var __jsx = React.createElement;
import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import Script from "next/script";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
import { useRouter } from "next/router";
import { CommonTypes } from "@dp/services";
var LoadingSpinner = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.LoadingSpinner;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var HandleAuthPage = function HandleAuthPage() {
  var store = useStore();
  var _useRouter = useRouter(),
    query = _useRouter.query;
  var isCreateAccountFlow = (query === null || query === void 0 ? void 0 : query.action) === CommonTypes.AuthAction.CREATE_ACCOUNT;
  var isLogoutAction = (query === null || query === void 0 ? void 0 : query.action) === CommonTypes.AuthAction.LOGOUT;
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("MyAccount")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      var _store$user2;
      if (isLogoutAction) {
        var _store$user;
        store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || _store$user.logout();
      } else if (!(store !== null && store !== void 0 && (_store$user2 = store.user) !== null && _store$user2 !== void 0 && _store$user2.isLoggedIn)) {
        var _store$user3;
        store === null || store === void 0 || (_store$user3 = store.user) === null || _store$user3 === void 0 || _store$user3.doLogin(isCreateAccountFlow);
      } else {
        store.platformUtil.goToURL("/customer-service/account-profile");
      }
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("meta", {
    httpEquiv: "Cache-Control",
    content: "no-store, must-revalidate"
  }), __jsx("title", null, i18next.t("title.myaccount.pagetitle", {
    defaultValue: "Account Profile"
  }))), __jsx(Script, {
    id: "go-to-home"
  }, "console.log(\"===>going back after 6 seconds\");\n  setTimeout(() => {\n    console.log(\"===>going back in 0 seconds\");\n    window.history.go(-1);\n  }, 6000);\n  if (window.performance) {\n    console.log(\"===>going back using performance\");\n    if (\n      window.performance.navigation &&\n      window.performance.navigation.type ==\n        window.performance.navigation?.TYPE_BACK_FORWARD\n    ) {\n      console.log(\"===>going back\");\n      window.history.go(-1);\n    } else if (\n      window.performance.getEntriesByType(\"navigation\").length > 0 &&\n      window.performance.getEntriesByType(\"navigation\")[0].type ===\n        \"back_forward\"\n    ) {\n      console.log(\"===>going back 2\");\n      window.history.go(-1);\n    }\n  }"), __jsx(LoadingSpinner, null));
};
HandleAuthPage.layout = PageLayout.NB_LAYOUT;
HandleAuthPage.layoutProps = {
  showMinimalHeader: true,
  hideLogoOnMinimalHeader: true
};
export default observer(HandleAuthPage);